const initialState = {
  accounts: 0,
  themes: 0,
  templates: 0,
  users: 0,
  customers: 0,
  plugins: 0,
  sendunits: 0,
  sendunitPools: 0
}

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getAccounts (state) {
      return state.accounts
    },
    getThemes (state) {
      return state.themes
    },
    getTemplates (state) {
      return state.templates
    },
    getUsers (state) {
      return state.users
    },
    getCustomers (state) {
      return state.customers
    },
    getPlugins (state) {
      return state.plugins
    },
    getSendunits (state) {
      return state.sendunits
    },
    getSendunitPools (state) {
      return state.sendunitPools
    }
  },
  actions: {
    getAccounts (state, payload) {
      return this.dispatch('accounts/getCollection')
        .then(accounts => {
          state.commit('updateAccounts', accounts)
        })
    },
    getThemes (state, payload) {
      return this.dispatch('themes/getCollection')
        .then(themes => {
          state.commit('updateThemes', themes)
        })
    },
    getTemplates (state, payload) {
      return this.dispatch('templates/getTemplates')
        .then(templates => {
          state.commit('updateTemplates', templates)
        })
    },
    getUsers (state, payload) {
      return this.dispatch('users/getCollection')
        .then(users => {
          state.commit('updateUsers', users)
        })
    },
    getCustomers (state, payload) {
      return this.dispatch('customers/getCollection')
        .then(customers => {
          state.commit('updateCustomers', customers)
        })
    },
    getPlugins (state, payload) {
      return this.dispatch('plugins/getCollection')
        .then(plugins => {
          state.commit('updatePlugins', plugins)
        })
    },
    getSendunits (state, payload) {
      return this.dispatch('sendunits/getCollection')
        .then(sendunits => {
          state.commit('updateSendunits', sendunits)
        })
    },
    getSendunitPools (state, payload) {
      return this.dispatch('sendunitPools/getCollection')
        .then(sendunitPools => {
          state.commit('updateSendunitPools', sendunitPools)
        })
    }
  },
  mutations: {
    updateAccounts (state, accounts) {
      state.accounts = accounts.meta.pagination.total
    },
    updateThemes (state, themes) {
      state.themes = themes.meta.pagination.total
    },
    updateTemplates (state, templates) {
      state.templates = templates.meta.pagination.total
    },
    updateUsers (state, users) {
      state.users = users.meta.pagination.total
    },
    updateCustomers (state, customers) {
      state.customers = customers.meta.pagination.total
    },
    updatePlugins (state, plugins) {
      state.plugins = plugins.meta.pagination.total
    },
    updateSendunits (state, sendunits) {
      state.sendunits = sendunits.meta.pagination.total
    },
    updateSendunitPools (state, sendunitPools) {
      state.sendunitPools = sendunitPools.meta.pagination.total
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/store.js